/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import * as G2 from '@antv/g2';
import { Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import * as _ from 'lodash';
import { BaseSharedState } from '../../store/base.state';
import { RDMClientService } from '../../services/rdm-client.service';
import { ModalBuilderService } from '../../services/modal-builder.service';
import { RefType } from '../../interfaces/rdm-client.interface';
import { FormIframeComponent } from '../form-iframe/form-iframe.component';
import { takeUntil, filter } from 'rxjs/operators';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.less']
})

export class PreviewComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  @Input() value: any;
  rdmData: any = {}
  rdmDataList: any = [];
  rdmData$: Observable<any>;
  data: any;
  chart: any;
  page = 1;
  size = 10;
  itemSize = 10;
  bolSort = 'HouseBLNo,desc';
  isSpinning = false;
  expressCourier: any = {};

  constructor(private rdmService: RDMClientService, private modalService: ModalBuilderService, private store: Store) {
    this.rdmData$ = this.store.select(BaseSharedState.getRdmData);
    this.rdmService.getLOVs('kc-profile-treatment-recommended-actions')
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        this.rdmDataList = (<RefType[]>result['content'])[0].refValue
      })
    
    if (this.rdmData$) {
      this.rdmData$
        .pipe(
          takeUntil(this.destroy$),
          filter(res => res != null)
        )
        .subscribe(res => {
          this.rdmData = res
        })
    }
  }

  listOfParentData: any[] = [];
  listOfChildrenData: any[] = [];

  ngOnInit(): void {
    if (this.value && this.value.tgData) {
      setTimeout(() => {
        this.renderChart();
      }, 1500);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private renderChart() {
    const graph: any = document.getElementById('risktScore');
    graph.style.display = "block";

    this.chart = new G2.Chart({
      container: 'risktScore',
      width: 500,
      height: 363
    });
    this.chart.source(this.value.gDtata);
    this.chart.interval()
      .position('x*y')
      .color('x')
      .label('value', { offset: 10 });
    this.chart.render();

    if (this.value.type == 'EXPRESS_COURIER_BL') {
      graph.style.display = "none";
    }
  }

  getRdmDataByRefTypeAndCode(refTypeCode: string, code: string): string {
    const [item] = this.rdmService.getRefValues(refTypeCode).filter((item: any) => item.code == code);
    if (item) return item.label;
    else return 'NA';
  }

  getRdmDesc(label: string): string {
    const [item] = this.rdmDataList.filter((item: any) => item.code == label);
    if (item) return item.label;
    else return 'No description found';
  }

  viewDeclaration(data: any) {
    const viewDeclarationUrl = window.location.origin + window.location.pathname + '#/app/intelligencemgmt/profile-mgmt/view-profile/' + data.ruleId + '?isDialog=true';

    this.modalService.openModalForm(FormIframeComponent, {
      iFrameLink: viewDeclarationUrl
    }, '', 1100);
  }

  splitRecomndedAction(value: any): string[] {
    return _.split(value, ',')
  }

  splitRecomndedActionLabel(value: any): string[] {
    return _.split(value, '#&%')
  }

  viewRiskAssManBLProfileEntities(profileObj: any) {
    if(!this.value || !this.value.tgData)
      return;
    this.isSpinning = true;
    this.rdmService.getECManifestByID(this.value.tgData.messageId).subscribe((result: any) => {
      this.isSpinning = false;
      if(result.statusCode == 200){
        profileObj.isItemsDisplay = true;
        profileObj.expressCourier = result.content;
        profileObj.expressCourierItems = result.content.expressCourierItems;
      }
      this.isSpinning = false;
    }, (err: any) => {
      this.isSpinning = false;
    });
  }

  changePagination(pageNumber: number, profileObj: any) {
    this.isSpinning = true;
    profileObj.page = pageNumber;
    this.viewRiskAssManBLProfileEntities(profileObj);
  }
}
